import React, { useRef } from 'react';
import { X } from 'lucide-react';
import { detectMediaType } from '../../services/mediaService';

const MEDIA_BUTTONS = [
  { key: 'photo', emoji: '\uD83D\uDCF7', label: 'Add a Photo', sub: 'From your camera roll', accept: 'image/*' },
  { key: 'video', emoji: '\uD83D\uDCF9', label: 'Record a Video', sub: 'Tell it in your own voice', accept: 'video/*' },
  { key: 'audio', emoji: '\uD83C\uDF99', label: 'Record Your Voice', sub: 'Audio recording', accept: 'audio/*' },
  { key: 'file', emoji: '\uD83D\uDCC1', label: 'Upload a File', sub: 'Any photo or video file', accept: '*/*' },
];

const MediaUploadGrid = ({ mediaFiles, onFilesSelected, onRemoveFile }) => {
  const fileInputRefs = useRef({});

  const handleButtonClick = (key) => {
    fileInputRefs.current[key]?.click();
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      onFilesSelected(files);
    }
    // Reset so the same file can be selected again
    e.target.value = '';
  };

  return (
    <div className="space-y-4">
      {/* 2x2 grid of action buttons */}
      <div className="grid grid-cols-2 gap-3 sm:gap-4">
        {MEDIA_BUTTONS.map(({ key, emoji, label, sub, accept }) => (
          <React.Fragment key={key}>
            <button
              type="button"
              onClick={() => handleButtonClick(key)}
              className="flex flex-col items-center justify-center text-center p-6 sm:p-5 rounded-2xl border-2 border-border-gray bg-panel-gray cursor-pointer hover:border-primary-green hover:bg-green-50 transition-all duration-150 min-h-[110px] sm:min-h-[100px]"
            >
              <span className="text-4xl sm:text-3xl mb-2">{emoji}</span>
              <span className="text-lg sm:text-base font-semibold text-text-dark mb-1">{label}</span>
              <span className="text-sm text-text-medium">{sub}</span>
            </button>
            <input
              ref={(el) => { fileInputRefs.current[key] = el; }}
              type="file"
              accept={accept}
              multiple
              onChange={handleFileChange}
              className="hidden"
            />
          </React.Fragment>
        ))}
      </div>

      {/* File pills */}
      {mediaFiles.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {mediaFiles.map((media) => {
            const name = media.name || media.file?.name || 'Unnamed file';
            return (
              <div
                key={media.id}
                className="bg-green-50 text-primary-green text-sm px-3 py-1 rounded-full flex items-center gap-2"
              >
                <span>\uD83D\uDCCE {name}</span>
                <button
                  type="button"
                  onClick={() => onRemoveFile(media.id)}
                  className="hover:text-red-600 transition-colors"
                  aria-label={`Remove ${name}`}
                >
                  <X size={14} />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MediaUploadGrid;
